import React from "react";
const ForeignerAuthenticationServiceContext = React.createContext({
    isLoading: false,
    process:null,
    pid:null,
    components:null,
    token:null,
    handleUpdateStep:()=>{},
    handleLoading:()=>{},
    handleProcess:()=>{},
    handleError:()=>{},
    handleComponents:()=>{},
    handleGetProcess:()=>{},
    handleCreateProcess:()=>{},
    handleRedirectToDivar:()=>{}


});
export default ForeignerAuthenticationServiceContext;